import Repository from "./Repository";

const GET_SEO_STATIC_PAGES = "/seo_static_pages";

export default {
  getMetaSeoStaticPages(payload) {
    return Repository.post(transformRoute2(GET_SEO_STATIC_PAGES), payload);
  },
};

const transformRoute = (route) => {
  return `/forms/get${route}`;
};
const transformRoute2 = (route) => {
  return `/forms/formGet${route}`;
};
